import {
    FETCH_COMMODITIES_STARTED,
    FETCH_COMMODITIES_SUCCESS,
    FETCH_COMMODITIES_ERROR,

    POST_COMMODITY_STARTED,
    POST_COMMODITY_SUCCESS,
    POST_COMMODITY_ERROR,

    PUT_COMMODITY_STARTED,
    PUT_COMMODITY_SUCCESS,
    PUT_COMMODITY_ERROR,

    DELETE_COMMODITY_STARTED,
    DELETE_COMMODITY_SUCCESS,
    DELETE_COMMODITY_ERROR
} from './types';

export const fetchCommoditiesStarted = () => ({
    type : FETCH_COMMODITIES_STARTED,
})
export const fetchCommoditiesSuccess = (data: any) => ({
    type        : FETCH_COMMODITIES_SUCCESS,
    commodities  : data,
})
export const fetchCommoditiesError = (error:any) => ({
    type : FETCH_COMMODITIES_ERROR,
    error: error
})

export const postCommodityStarted = () => ({
    type: POST_COMMODITY_STARTED
})
export const postCommoditySuccess = () => ({
    type: POST_COMMODITY_SUCCESS
})
export const postCommodityError = () => ({
    type: POST_COMMODITY_ERROR
})

export const putCommodityStarted = () => ({
    type: PUT_COMMODITY_STARTED
})
export const putCommoditySuccess = () => ({
    type: PUT_COMMODITY_SUCCESS
})
export const putCommodityError = () => ({
    type: PUT_COMMODITY_ERROR
})

export const deleteCommodityStarted = () => ({
    type: DELETE_COMMODITY_STARTED
})
export const deleteCommoditySuccess = () => ({
    type: DELETE_COMMODITY_SUCCESS
})
export const deleteCommodityError = () => ({
    type: DELETE_COMMODITY_ERROR
})